import { render, staticRenderFns } from "./comEditAddr.vue?vue&type=template&id=6bad73c9&scoped=true&"
import script from "./comEditAddr.vue?vue&type=script&lang=js&"
export * from "./comEditAddr.vue?vue&type=script&lang=js&"
import style0 from "./comEditAddr.vue?vue&type=style&index=0&id=6bad73c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad73c9",
  null
  
)

export default component.exports